export const key = '6LfYFScTAAAAAIyS_DDLc3YZn9R9wFu6UlaPiTht';



/** WEBPACK FOOTER **
 ** ./src/constants/googleCaptcha.js
 **/